import React from "react";
import * as dc from "dc";
import * as d3 from 'd3';
import { ChartTemplate } from "./chartTemplate";

const barChartFunc = (divRef, ndx) => {
    const BAR_WIDTH = 40;
    let name;
    let myChart;
    let year;
    let latest;
    let n;
    const dimension = ndx.dimension(function (d) {
         year = d.dsubmissiom.getFullYear();
         latest = d.years.sort();
         n = d.years.length-1
         if(d.years.length == 1) {
           name = ["",latest[0]-3,latest[0]-2,latest[0]-1,latest[0]]
         } else
         if(d.years.length == 2) {
           name = ["",latest[1]-2,latest[1]-1,latest[1],latest[0]]
         } else
         if(d.years.length == 3) {
           name = ["",latest[2]-1,latest[2],latest[1],latest[0]]
         } else name = latest
        // if(year < 2009) {
        //   year = 2018;
        // } else year = 2019;
        //console.log(year);

        return d.year;
        //name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    });
    console.log("n "+n);
    // if(n === 0) myChart = <div>latest[0]</div>;
    // else {
    myChart = dc.barChart(divRef);
    const group = dimension.group().reduce(
     function(p, v) { // add
       ++p.count;
       if(p.count > 0) {
         p.totalWords += v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary += v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] += 1
         }
         else{
             p.p_ids[v.project_id] = 1;
             p.id_count++;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function(p, v) { // remove
       --p.count;
       if(p.count > 0) {
         p.totalWords -= v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary -= v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] -= 1
         }
         if(p.p_ids[v.project_id] === 0){
             delete p.p_ids[v.project_id];
             p.id_count--;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function() { // init
         return {count: 0, totalWords: 0, avgWords: 0, totalVocabulary: 0, avgVocabulary: 0, id_count: 0, p_ids: {}};
     }
   );

    myChart
    .dimension(dimension)
    .group(group)
    .valueAccessor(function (p) {
       return p.value.count ;
     })
    .x(d3.scaleOrdinal().domain(name))
    .xUnits(dc.units.ordinal)
    .brushOn(false)
    .elasticY(true)
    .height(142)
    .barPadding(0.1)
    .outerPadding(0.05)
    .colors(["#065FE5"])
    .margins({ top: 5, right: 25, bottom: 25, left: 50 })
    .yAxis().ticks(6)

    //.labelOffsetX(-50)

    // myChart.on('preRedraw', function(chart) {
    //     chart.width(chart.group().all().length * BAR_WIDTH);
    // });
  //}

    return myChart

}

export const BarChart2 = props => (
  <ChartTemplate chartFunction={barChartFunc} title={props.title} dim={props.dim} metric={props.metric}
   showMetricsSelector={props.showMetricsSelector}/>
)
